'use strict';

function isPOJO(obj) {
    var proto;
    return obj && typeof obj == 'object' &&
        ((proto = Object.getPrototypeOf(obj)) === Object.prototype || proto == null);
}
exports.isPOJO = isPOJO;

function forEach(obj, callback, context) {
    var prop;
    // Use for .. in since we need enumerable properties from the prototype chain
    // eslint-disable-next-line guard-for-in, curly
    for (prop in obj) try {
        Function.prototype.call.call(callback, context, obj[prop], prop, obj);
    } catch (e) { /* skip over errors */ }
}
exports.forEach = forEach;



//////////////////
// WEBPACK FOOTER
// ./~/@getgo/logger/plugins/helpers/object_helpers.js
// module id = 721
// module chunks = 0